module.exports = __webpack_public_path__ + "img/no_incidences.6cd2f3ec.svg";